export const twoSpacesAtStringEdgeRegExp = /^\s{2,}|\s{2,}$/g;

export default (string = '') =>
  string.replace(twoSpacesAtStringEdgeRegExp, ' ');
